import Headroom from 'headroom.js';
import * as Event from '../tools/Event';
import { MQ } from '../tools/MQ';
import { addClass, removeClass } from '../tools/DOM';
import throttle from 'lodash.throttle';


export const init = () => {
	const OPTIONS = {
		tolerance: {
			down: 10,
			up: 20,
		},
		offset: 200,
	};
	const FIXED_CLASS = 'header-fixed';
	const header = document.querySelector('.header');
	const html = document.documentElement;
	const headroom = new Headroom(header, OPTIONS);
	let isInit = false;

	const prepare = () => {
		const isMobile = MQ('tabletMax');

		if (isMobile) {
			init();
		} else {
			destroy();
		}
	};

	const init = () => {
		if (isInit) return;

		headroom.init();
		addClass(html, FIXED_CLASS);
		isInit = true;
	};

	const destroy = () => {
		if (!isInit) return;

		headroom.destroy();
		removeClass(html, FIXED_CLASS);
		isInit = false;
	};


	prepare();

	Event.on(window, 'resize', throttle(prepare, 100));
};



// WEBPACK FOOTER //
// ./src/js/components/header.js